import React from 'react';
import SectionHeading from '../common/section-heading-component';
import { FINANCIAL_SERVICES_DEFAULT_PRODUCTS } from './constants';
import { FinancialServicesProps } from '../types';
import TrustedByBrandsSection from '../trusted-by-brands-section';
import { handleTrack } from '../../../utils/tracker';

const FinancialServicesSection: React.FC<FinancialServicesProps> = ({
  products_horizontal = FINANCIAL_SERVICES_DEFAULT_PRODUCTS,
}) => {
  const productsData = products_horizontal;

  return (
    <div className="bg-gray-100 py-20 md:py-16 sm:py-16">
      <div className=" mx-auto px-4 wg-container">
        {/* Header Section */}
        <SectionHeading
          heading="India's largest tax and financial services platform"
          subHeading="Explore our wide range of software solutions"
          classname="sm:text-left"
        />

        {/* Products Grid */}
        <div className="flex flex-wrap items-center">
          {productsData.map((card, index) => (
            <div
              key={index}
              className="w-1/4 p-4 sm:px-0 sm:pb-6 sm:pt-0 md:w-1/2 sm:w-full"
            >
              <a
                href={card.link}
                onClick={() => {
                  handleTrack({ label: 'inpage_cta_' + card.title });
                }}
                className="block"
                target="__blank"
              >
                <div
                  data-label={card.title}
                  className="bg-white shadow-sm cursor-pointer rounded-xl relative p-6 lg:p-4 transform transition-transform duration-200 hover:scale-105"
                >
                  {/* Card Content */}
                  <div className="flex items-center">
                    <div className="pr-4">
                      <img
                        alt={card.title}
                        width="60"
                        height="60"
                        src={card.icon}
                        className="w-15 h-15 object-contain"
                      />
                    </div>
                    <div>
                      <p className="text-xl font-bold text-font-500">
                        {card.title}
                      </p>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="pt-3 md:pb-2 sm:pt-3">
                    {/* Desktop/Tablet Description */}
                    <p className="w-full text-base h-12 md:w-full sm:w-full sm:h-10 sm:hidden">
                      {card.description}
                    </p>
                    {/* Mobile Description */}
                    <p className="md:hidden xl:hidden lg:hidden w-full text-base xl:h-auto md:w-full sm:w-full sm:h-10 sm:block hidden">
                      {card.mobile_description}
                    </p>
                  </div>

                  {/* Know More Button */}
                  <div className="text-sm font-bold flex items-center text-gray-700 mt-6">
                    <span className="pr-1">Know more</span>
                    <span className="font-medium">&nbsp; →</span>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        <TrustedByBrandsSection />
      </div>
    </div>
  );
};

export default FinancialServicesSection;
